module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero__overlay"
  }), _c('div', {
    staticClass: "hero__video"
  }, [_c('video', {
    attrs: {
      "autoplay": "autoplay",
      "loop": "loop"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.video,
      "poster": _vm.props.poster
    }
  })]), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    staticClass: "hero__logo",
    attrs: {
      "name": _vm.props.logo
    }
  })], 1)], 1), _c('div', {
    staticClass: "hero__contact-bar"
  }, [_c('div', {
    staticClass: "hero__contact-content"
  }, [_c('div', {
    staticClass: "hero__item"
  }, [_c('a', {
    staticClass: "hero__phone-button",
    attrs: {
      "href": _vm.props.links.phone_href,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.props.links.phone_label))])])]), _c('div', {
    staticClass: "hero__item"
  }, [_c('div', {
    staticClass: "hero__review-button"
  }, [_c('span', [_vm._v(_vm._s(_vm.props.links.review.label)), _c('div', {
    staticClass: "hero__dropdown"
  }, [_c('a', {
    staticClass: "hero__dropdown-item",
    attrs: {
      "href": _vm.props.links.review.href_windsong,
      "target": "_blank"
    }
  }, [_vm._v("Prescott Valley")]), _c('a', {
    staticClass: "hero__dropdown-item",
    attrs: {
      "href": _vm.props.links.review.href_ruth,
      "target": "_blank"
    }
  }, [_vm._v("Prescott")])])])])]), _c('div', {
    staticClass: "hero__item"
  }, [_c('div', {
    staticClass: "hero__request-appt"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("request appointment online")])])], 1)]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-pages__item"
  }, [_c('div', {
    staticClass: "hero-pages__request-appt portal_btn"
  }, [_c('a', {
    attrs: {
      "href": "https://app.orthopms.com/patient-referral/id/7b3c13e0-9dee-461b-a4d7-80b854f552dc",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PATIENT PORTAL")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e427668","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 550
// module chunks = 1